import React, { useState, useEffect } from "react";
import "./reactCart.css";
import lawService from "./simpleAjax.js";
import { Link, Navigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
function NewCart() {
  // const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  // let data = localStorage.getItem("reactPress");
  // console.log(data);
  const [searchParams, setSearchParams] = useSearchParams();
  const [agentAttend,setAgentAttend]=useState("Did Agent Attend Initial Consult?")
  const [params, setParams] = useState({});
  const [attorneys, setAttorneys] = useState([
    { id: " ", name: "No Lead Attorney Found" },
  ]);
  const [couponInput, setCouponInput] = useState({
    codeInput: "",
    clientEmail: "",
  });
  const [trustPlus, setTrustPlus] = useState({
    onlyTrustPlus: false,
    clientEmail: "",
  });
  const [confirmInput, setConfirmInput] = useState({
    clientConfirm: "",
    processorConfirm: "",
    processorConfirmId: null,
    searchedClient: false,
    clientId: null,
    isAgentPlan: false,
    providedNotary: false,
    binderNumber: 0,
    assignNumber: 0,
    familyNumber: 0,
    trustPlusNumber: 0,
    trustNumber: 0,
    trustNoDeedNumber: 0,
    deedNumber: 0,
    recordingNumber: 0,
    deedsToBeDrafted: 0,
    agentTrustNumber: 0,
    ammendNumber: 0,
    notaryNumber: 0,
    attorneyReviewNumber: 0,
    affidavitNumber: 0,
    designDeposit: 0,
    spouseConfirm: 0,
    moms25: false,
    attorneyAttend: false,
    trustPlusFirstName: "",
    trustPlusLastName: "",
    trustPlusPhone: "",
    trustPlusEmail: "",
  });
  const [prices] = useState({
    "Trust Guard Plan": "1295.00",
    "Trust Guard Plan (Old Pricing)": "1197.00",
    "Trust Guard Plan (No Deed)": "1349.00",
    "Trust Guard Plan Plus": "1895.00",
    "Family Guard Plan": "650.00",
    "Additional Deed": "200.00",
    "Assembled Padded Binder": "100.00",
    "Assignment of Business": "250.00",
    "Electronic Recording": "50.00",
    "Trust Guard Ammendment/Restatement": "350.00",
    "Affidavit of Death of Joint Tenant": "150.00",
    "Design Meeting Deposit": "100.00",
    Notary: "200.00",
    "Attorney Review": "399.00",
  });
  const [quantities, setQuantities] = useState({
    "Trust Guard Plan": "0",
    "Trust Guard Plan (No Deed)": 0,
    "Trust Guard Plan (Old Pricing)": "0",
    "Trust Guard Plan Plus": 0,
    "Family Guard Plan": "0",
    "Additional Deed": "0",
    "Assembled Padded Binder": "0",
    "Assignment of Business": "0",
    "Electronic Recording": "0",
    "Trust Guard Ammendment/Restatement": "0",
    "Affidavit of Death of Joint Tenant": "0",
    "Design Meeting Deposit": "0",
    Notary: "0",
    "Attorney Review": "0",
  });
  const [discounts, setDiscounts] = useState({
    IGN200: {
      value: -200,
      operator: "add",
      restriction: true,
    },
    IGNAGENT: {
      value: -200,
      operator: "add",
      restriction: quantities["Trust Guard Plan"] >= 1,
    },
    NOTARY120: {
      value: -200,
      operator: "add",
      restriction: true,
    },
    MOMS25: {
      value: 0,
      operator: "add",
      restriction: true,
    },
    SUMMER50: {
      value: -50,
      operator: "add",
      restriction: true,
    },
    used: {},
  });
  const [cartTotal, setCartTotal] = useState({
    finalPrice: 0,
    appliedDiscounts: 0,
    actualValue: 0,
    depositAmount: 0,
    prediscount: 0,
  });

  const [locationState, setLocationState] = useState({
    notes: "",
    price: 0,
    isCustom: false,
    readyToCheckout: false,
    spouse: 0,
    name: "",
  });

  const nullQuant = {
    "Trust Guard Plan": "0",
    "Trust Guard Plan (No Deed)": "0",
    "Trust Guard Plan (Old Pricing)": "0",
    "Trust Guard Plan Plus": "0",
    "Family Guard Plan": "0",
    "Additional Deed": "0",
    "Assembled Padded Binder": "0",
    "Assignment of Business": "0",
    "Electronic Recording": "0",
    "Trust Guard Ammendment/Restatement": "0",
    "Affidavit of Death of Joint Tenant": "0",
    "Design Meeting Deposit": "0",
    Notary: "0",
    "Attorney Review": "0",
  };
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
const onAgentAttendChanged=(e)=>{
    let value = e.target.value
 setAgentAttend((prevState)=>{
    return value
 })
}
  const checkoutClicked = async () => {
    if (confirmInput.clientConfirm === "") {
      alert("Please Input Client Name");
    } else if (confirmInput.processorConfirmId === "") {
      alert("Please input Lead Attorney");
    } 
    else if (agentAttend === "Did Agent Attend Initial Consult?") {
      alert("Did Agent Attend Initial Consult? is required.");
    }
    else if (
      quantities["Electronic Recording"] > 0 &&
      quantities["Notary"] < 1 &&
      confirmInput?.notaryNumber < 1
    ) {
      alert("E-recordings cannot be purchased without a notary.");
    } else {
      let planAdded = "";
      planAdded =
        quantities["Trust Guard Plan"] > 0 ||
        quantities["Family Guard Plan"] > 0 ||
        quantities["Trust Guard Plan (No Deed)"] > 0 ||
        quantities["Trust Guard Plan Plus"] > 0 ||
        quantities["Trust Guard Plan (Old Pricing)"] > 0
          ? decidePlan()
          : "";
      if (planAdded) {
        planAdded = `${planAdded} for `;
      }
      // let planAdded=decidePlan()
      let total = cartTotal.finalPrice;
      let confidoInputString =
        `${planAdded} ${confirmInput.clientConfirm} (${confirmInput.processorConfirm}), ` +
        (quantities["Additional Deed"] > 0
          ? `${
              quantities["Additional Deed"] > 1
                ? quantities["Additional Deed"]
                : ""
            } Additional Deed${quantities["Additional Deed"] > 1 ? "s" : ""}, `
          : "") +
        (quantities["Assembled Padded Binder"] > 0
          ? `${
              quantities["Assembled Padded Binder"] > 1
                ? quantities["Assembled Padded Binder"]
                : ""
            } Assembled Padded Binder${
              quantities["Assembled Padded Binder"] > 1 ? "s" : ""
            }, `
          : "") +
        (quantities["Electronic Recording"] > 0
          ? `${
              quantities["Electronic Recording"] > 1
                ? quantities["Electronic Recording"]
                : ""
            } Electronic Recording${
              quantities["Electronic Recording"] > 1 ? "s" : ""
            }, `
          : "") +
        (quantities["Assignment of Business"] > 0
          ? `${
              quantities["Assignment of Business"] > 1
                ? quantities["Assignment of Business"]
                : ""
            } Assignment${
              quantities["Assignment of Business"] > 1
                ? "s of Business"
                : " of Business"
            }, `
          : "") +
        (quantities["Trust Guard Ammendment/Restatement"] > 0
          ? `${
              quantities["Trust Guard Ammendment/Restatement"] > 1
                ? quantities["Trust Guard Ammendment/Restatement"]
                : ""
            } Trust Guard Ammendment or Restatement${
              quantities["Trust Guard Ammendment/Restatement"] > 1 ? "s" : ""
            }, `
          : "") +
        (quantities["Notary"] > 0
          ? `${quantities["Notary"] > 1 ? quantities["Notary"] : ""} Notar${
              quantities["Notary"] > 1 ? "ies" : "y"
            }, `
          : "") +
        (quantities["Attorney Review"] > 0
          ? `${
              quantities["Attorney Review"] > 1
                ? quantities["Attorney Review"]
                : ""
            } "Attorney Review"${
              quantities["Attorney Review"] > 1 ? "s" : ""
            }, `
          : "") +
        (quantities["Affidavit of Death of Joint Tenant"] > 0
          ? `${
              quantities["Affidavit of Death of Joint Tenant"] > 1
                ? quantities["Affidavit of Death of Joint Tenant"]
                : ""
            } Affidavit${
              quantities["Affidavit of Death of Joint Tenant"] > 1
                ? "s of Death of Joint Tenant"
                : " of Death of Joint Tenant"
            }, `
          : "") +
        (quantities["Design Meeting Deposit"] > 0
          ? `${
              quantities["Design Meeting Deposit"] > 1
                ? quantities["Design Meeting Deposit"]
                : ""
            }Design Meeting Deposit${
              quantities["Design Meeting Deposit"] > 1 ? "s" : ""
            }, `
          : "");
      confidoInputString = confidoInputString.slice(0, -2);
      //Family Guard Plans:${quantities["Family Guard Plan"]}; Trust Guard Plans:${quantities["Trust Guard Plan"]}; Additional Deeds:${quantities["Additional Deed"]}; Binders:${quantities["Assembled Padded Binder"]}; Assignments:${quantities["Assignment of Business"]}`;
      total = total.toString();
      let total2 = total + "00";
      total2 = Number(total2);
      const agentCodeUsed = discounts.used["IGNAGENT"] ? true : false;
      const totalToPush = cartTotal.actualValue + total2;
      const binderToPush =
        Number(confirmInput.binderNumber) +
        Number(quantities["Trust Guard Plan Plus"]) +
        Number(quantities["Assembled Padded Binder"]) +
        (discounts.used["IGNAGENT"]
          ? Number(quantities["Trust Guard Plan"])
          : 0);
      const assignToPush =
        Number(confirmInput.assignNumber) +
        Number(quantities["Assignment of Business"]);
      const familyToPush =
        Number(confirmInput.familyNumber) +
        Number(quantities["Family Guard Plan"]);
      const trustPlusToPush =
        Number(confirmInput.trustPlusNumber) +
        Number(quantities["Trust Guard Plan Plus"]);
      const trustToPush =
        agentCodeUsed === false
          ? Number(confirmInput.trustNumber) +
            Number(quantities["Trust Guard Plan"]) +
            Number(quantities["Trust Guard Plan (No Deed)"]) +
            Number(quantities["Trust Guard Plan (Old Pricing)"])
          : Number(confirmInput.trustNumber);
      const deedToPush =
        Number(confirmInput.deedNumber) + Number(quantities["Additional Deed"]);
      const recordingToPush =
        Number(confirmInput.recordingNumber) +
        Number(quantities["Electronic Recording"]) +
        (discounts.used["IGNAGENT"]
          ? Number(quantities["Trust Guard Plan"])
          : 0) +
        Number(quantities["Trust Guard Plan Plus"]);
      const draftedDeedsToPush =
        Number(confirmInput.deedsToBeDrafted) +
        Number(quantities["Additional Deed"]) +
        Number(quantities["Trust Guard Plan"]) +
        Number(quantities["Trust Guard Plan Plus"]) +
        Number(quantities["Trust Guard Plan (Old Pricing)"]);
      const agentTrustToPush =
        agentCodeUsed === true
          ? Number(confirmInput.agentTrustNumber) +
            Number(quantities["Trust Guard Plan"]) +
            Number(quantities["Trust Guard Plan (No Deed)"]) +
            Number(quantities["Trust Guard Plan (Old Pricing)"])
          : Number(confirmInput.agentTrustNumber);
      const ammendtoPush =
        Number(confirmInput.ammendNumber) +
        Number(quantities["Trust Guard Ammendment/Restatement"]);
      const notaryToPush =
        Number(confirmInput.notaryNumber) +
        Number(quantities["Notary"]) +
        Number(quantities["Trust Guard Plan Plus"]) +
        (discounts.used["IGNAGENT"]
          ? Number(quantities["Trust Guard Plan"])
          : 0);
      const attorneyReviewToPush =
        Number(confirmInput.attorneyReviewNumber) +
        Number(quantities["Attorney Review"]) +
        Number(quantities["Trust Guard Plan Plus"]);
      const affidavitToPush =
        Number(confirmInput.affidavitNumber) +
        Number(quantities["Affidavit of Death of Joint Tenant"]);
      const depositToPush =
        Number(quantities["Design Meeting Deposit"]) * 10000;
      //let lawmaticsInputString = `Family Guard Plans:${familyToPush}; Trust Guard Plans:${trustToPush}; Additional Deeds:${deedToPush}; Binders:${binderToPush}; Assignments:${assignToPush}`;
      let lawmaticsInputString =
        `${planAdded} ${confirmInput.clientConfirm} (${confirmInput.processorConfirm}) ` +
        (deedToPush > 0
          ? `${deedToPush > 1 ? deedToPush : ""} Additional Deed${
              deedToPush > 1 ? "s" : ""
            }, `
          : "") +
        (binderToPush > 0
          ? `${binderToPush > 1 ? binderToPush : ""} Assembled Padded Binder${
              binderToPush > 1 ? "s" : ""
            }, `
          : "") +
        (recordingToPush > 0
          ? `${
              recordingToPush > 1 ? recordingToPush : ""
            } Electronic Recording${recordingToPush > 1 ? "s" : ""}, `
          : "") +
        (assignToPush > 0
          ? `${assignToPush > 1 ? assignToPush : ""} Assignment${
              assignToPush > 1 ? "s of Business" : " of Business"
            }`
          : "") +
        (ammendtoPush > 0
          ? `${
              ammendtoPush > 1 ? ammendtoPush : ""
            } Trust Guard Ammendment or Restatement${
              ammendtoPush > 1 ? "s" : ""
            }, `
          : "") +
        (notaryToPush > 0
          ? `${notaryToPush > 1 ? notaryToPush : ""} Notar${
              notaryToPush > 1 ? "ies" : "y"
            }, `
          : "") +
        (attorneyReviewToPush > 0
          ? `${
              attorneyReviewToPush > 1 ? attorneyReviewToPush : ""
            } Attorney Review${attorneyReviewToPush > 1 ? "s" : ""}, `
          : "") +
        (quantities["Affidavit of Death of Joint Tenant"] > 0
          ? `${
              quantities["Affidavit of Death of Joint Tenant"] > 1
                ? quantities["Affidavit of Death of Joint Tenant"]
                : ""
            } Affidavit${
              quantities["Affidavit of Death of Joint Tenant"] > 1
                ? "s of Death of Joint Tenant"
                : " of Death of Joint Tenant"
            }, `
          : "") +
        (depositToPush > 0
          ? `${depositToPush > 1 ? depositToPush : ""} Design Meeting Deposit${
              depositToPush > 1 ? "s" : ""
            }, `
          : "");
      lawmaticsInputString = lawmaticsInputString.slice(0, -2);
      const lawmaticsData = {
        clientId: confirmInput.clientId,
        binders: binderToPush,
        deeds: deedToPush,
        assignments: assignToPush,
        familyPlans: familyToPush,
        trustPlans: trustToPush,
        trustPlusPlans: trustPlusToPush,
        isAgentPlan: discounts.used["IGNAGENT"]
          ? true
          : confirmInput.isAgentPlan,
        ownNotary: discounts.used["NOTARY120"]
          ? true
          : confirmInput.providedNotary,
        isSummer50: discounts.used["SUMMER50"] ? true : false,
        lawmaticsInputString: lawmaticsInputString,
        actualValue: totalToPush,
        recordingNumber: recordingToPush,
        deedsToBeDrafted: draftedDeedsToPush,
        agentTrust: agentTrustToPush,
        ammendments: ammendtoPush,
        notaries: notaryToPush,
        attorneyReviews: attorneyReviewToPush,
        affidavits: affidavitToPush,
        depositAmount: depositToPush,
        moms25: discounts.used["MOMS25"] ? true : confirmInput.moms25,
      };
      let copyquants = { ...quantities };
      delete copyquants["Design Meeting Deposit"];
      delete copyquants["Additional Deed"];
      delete copyquants["Electronic Recording"];
      delete copyquants["Assembled Padded Binder"];
      delete copyquants["Affidavit of Death of Joint Tenant"];
      delete copyquants["Assignment of Business"];
      delete copyquants["Trust Guard Ammendment/Restatement"];
      delete copyquants["Design Meeting Deposit"];
      delete copyquants["Notary"];
      delete copyquants["Attorney Review"];
      const areWeMarkingPayment = Object.values(copyquants).some(
        (item) => item > 0,
      );
      setLocationState((prevState) => {
        let pd = {
          ...prevState,
        };
        pd.notes = confidoInputString;
        pd.price = total2;
        pd.clientObj = lawmaticsData;
        pd.clientObj.leadAttorneyId = confirmInput.processorConfirmId;
        pd.readyToCheckout = true;
        pd.fieldAgent = confirmInput.fieldAgentId;
        pd.spouse = confirmInput.spouseConfirm;
        pd.name = confirmInput.clientConfirm;
        pd.email = couponInput.clientEmail;
        pd.isWillPlan = quantities["Family Guard Plan"] > 0 ? true : false;
        pd.isAgentPlan = lawmaticsData.isAgentPlan;
        pd.areWeMarkingPayment = areWeMarkingPayment;
        pd.leadAttorney = confirmInput.leadAttorney;
        pd.originatingAttorney = confirmInput.originatingAttorney;
        pd.moms25 = lawmaticsData.moms25;
        pd.contactId = confirmInput.contactId;
        pd.isAttorneyReferral = confirmInput.isAttorneyReferral;
        pd.attorneyAttend = agentAttend;
        pd.agentSell = params.param == "trustplus" ? true : false;
        pd.clientObj.trustPlusTag =
          quantities["Trust Guard Plan Plus"] > 0
            ? "Attorney Sold TrustGuard Plus+ Plan"
            : "Simple Plan";
        pd.clientObj.isAttorneyTrustPlus =
          quantities["Trust Guard Plan Plus"] > 0 ? true : false;
        return pd;
      });
    }
  };

  const trustPlusCheckoutClicked = (e) => {
    e.preventDefault();
    const agentCodeUsed = discounts.used["FINAGENT"] ? true : false;
    let total = cartTotal.finalPrice;
    total = total.toString();
    let total2 = total + "00";
    total2 = Number(total2);
    let planAdded = "";
    planAdded =
      quantities["Trust Guard Plan"] > 0 ||
      quantities["Family Guard Plan"] > 0 ||
      quantities["Trust Guard Plan (No Deed)"] > 0 ||
      quantities["Trust Guard Plan Plus"] > 0 ||
      quantities["Trust Guard Plan (Old Pricing)"] > 0
        ? decidePlan()
        : "";
    if (planAdded) {
      planAdded = `${planAdded} for `;
    }
    let confidoInputString =
      `${planAdded}${confirmInput.trustPlusFirstName} ${confirmInput.trustPlusLastName} ` +
      (quantities["Additional Deed"] > 0
        ? `${
            quantities["Additional Deed"] > 1
              ? quantities["Additional Deed"]
              : ""
          } Additional Deed${quantities["Additional Deed"] > 1 ? "s" : ""}, `
        : "") +
      (quantities["Assembled Padded Binder"] > 0
        ? `${
            quantities["Assembled Padded Binder"] > 1
              ? quantities["Assembled Padded Binder"]
              : ""
          } Assembled Padded Binder${
            quantities["Assembled Padded Binder"] > 1 ? "s" : ""
          }, `
        : "") +
      (quantities["Electronic Recording"] > 0
        ? `${
            quantities["Electronic Recording"] > 1
              ? quantities["Electronic Recording"]
              : ""
          } Electronic Recording${
            quantities["Electronic Recording"] > 1 ? "s" : ""
          }, `
        : "") +
      (quantities["Assignment of Business"] > 0
        ? `${
            quantities["Assignment of Business"] > 1
              ? quantities["Assignment of Business"]
              : ""
          } Assignment${
            quantities["Assignment of Business"] > 1
              ? "s of Business"
              : " of Business"
          }, `
        : "") +
      (quantities["Trust Guard Ammendment/Restatement"] > 0
        ? `${
            quantities["Trust Guard Ammendment/Restatement"] > 1
              ? quantities["Trust Guard Ammendment/Restatement"]
              : ""
          } Trust Guard Ammendment or Restatement${
            quantities["Trust Guard Ammendment/Restatement"] > 1 ? "s" : ""
          }, `
        : "") +
      (quantities["Notary"] > 0
        ? `${quantities["Notary"] > 1 ? quantities["Notary"] : ""} Notar${
            quantities["Notary"] > 1 ? "ies" : "y"
          }, `
        : "") +
      (quantities["Attorney Review"] > 0
        ? `${
            quantities["Attorney Review"] > 1
              ? quantities["Attorney Review"]
              : ""
          } "Attorney Review"${quantities["Attorney Review"] > 1 ? "s" : ""}, `
        : "") +
      (quantities["Affidavit of Death of Joint Tenant"] > 0
        ? `${
            quantities["Affidavit of Death of Joint Tenant"] > 1
              ? quantities["Affidavit of Death of Joint Tenant"]
              : ""
          } Affidavit${
            quantities["Affidavit of Death of Joint Tenant"] > 1
              ? "s of Death of Joint Tenant"
              : " of Death of Joint Tenant"
          }, `
        : "") +
      (quantities["Design Meeting Deposit"] > 0
        ? `${
            quantities["Design Meeting Deposit"] > 1
              ? quantities["Design Meeting Deposit"]
              : ""
          }Design Meeting Deposit${
            quantities["Design Meeting Deposit"] > 1 ? "s" : ""
          }, `
        : "");
    const binderToPush =
      Number(quantities["Assembled Padded Binder"]) +
      Number(quantities["Trust Guard Plan Plus"]);
    const assignToPush = Number(quantities["Assignment of Business"]);
    const familyToPush = Number(quantities["Family Guard Plan"]);
    const trustPlusToPush = Number(quantities["Trust Guard Plan Plus"]);
    const trustToPush =
      agentCodeUsed === false
        ? Number(quantities["Trust Guard Plan"]) +
          Number(quantities["Trust Guard Plan (No Deed)"]) +
          Number(quantities["Trust Guard Plan (Old Pricing)"])
        : 0;
    const deedToPush = Number(quantities["Additional Deed"]);
    const recordingToPush =
      Number(quantities["Electronic Recording"]) +
      Number(quantities["Trust Guard Plan"]) +
      Number(quantities["Trust Guard Plan (Old Pricing)"]) +
      Number(quantities["Additional Deed"]) +
      Number(quantities["Trust Guard Plan Plus"]);
    const draftedDeedsToPush =
      Number(quantities["Additional Deed"]) +
      Number(quantities["Trust Guard Plan"]) +
      Number(quantities["Trust Guard Plan (Old Pricing)"]) +
      Number(quantities["Trust Guard Plan Plus"]);
    const agentTrustToPush =
      agentCodeUsed === true
        ? Number(quantities["Trust Guard Plan"]) +
          Number(quantities["Trust Guard Plan (No Deed)"]) +
          Number(quantities["Trust Guard Plan (Old Pricing)"])
        : 0;
    const ammendtoPush = Number(
      quantities["Trust Guard Ammendment/Restatement"],
    );
    const notaryToPush =
      Number(confirmInput.notaryNumber) +
      Number(quantities["Notary"]) +
      Number(quantities["Trust Guard Plan Plus"]) +
      (discounts.used["IGNAGENT"] ? Number(quantities["Trust Guard Plan"]) : 0);
    const attorneyReviewToPush =
      Number(confirmInput.attorneyReviewNumber) +
      Number(quantities["Attorney Review"]) +
      Number(quantities["Trust Guard Plan Plus"]);
    const affidavitToPush = Number(
      quantities["Affidavit of Death of Joint Tenant"],
    );
    const depositToPush = Number(quantities["Design Meeting Deposit"]) * 10000;
    setLocationState((prevState) => {
      //let trustPlusClient = {};
      const trustPlusClient = {
        clientId: confirmInput.clientId,
        binders: binderToPush,
        deeds: deedToPush,
        assignments: assignToPush,
        familyPlans: familyToPush,
        trustPlans: trustToPush,
        trustPlusPlans: trustPlusToPush,
        isAgentPlan: discounts.used["IGNAGENT"]
          ? true
          : confirmInput.isAgentPlan,
        ownNotary: discounts.used["NOTARY120"]
          ? true
          : confirmInput.providedNotary,
        isSummer50: discounts.used["SUMMER50"] ? true : false,
        lawmaticsInputString: confidoInputString,
        actualValue: total2,
        recordingNumber: recordingToPush,
        deedsToBeDrafted: draftedDeedsToPush,
        agentTrust: agentTrustToPush,
        ammendments: ammendtoPush,
        notaries: notaryToPush,
        attorneyReviews: attorneyReviewToPush,
        affidavits: affidavitToPush,
        depositAmount: depositToPush,
        moms25: discounts.used["MOMS25"] ? true : confirmInput.moms25,
        trustPlusTag: "Agent Sold TrustGuard Plus+ Plan",
      };
      trustPlusClient.firstName = confirmInput.trustPlusFirstName;
      trustPlusClient.lastName = confirmInput.trustPlusLastName;
      trustPlusClient.email = confirmInput.trustPlusEmail;
      trustPlusClient.phone = confirmInput.trustPlusPhone;
      trustPlusClient.trustPlusNumber = quantities["Trust Guard Plan Plus"];
      let pd = {
        ...prevState,
      };
      pd.notes = `${confidoInputString}`;
      pd.price = total2;
      pd.readyToCheckout = true;
      pd.isWillPlan = false;
      pd.isAgentPlan = false;
      pd.areWeMarkingPayment = true;
      pd.isEPSTrustPlusPurchase = true;
      pd.isCustom = false;
      pd.trustPlusClient = trustPlusClient;
      pd.agentSell = params.param == "trustplus" ? true : false;
      return pd;
    });
  };

  const getAttorneyNames = async () => {
    for (let i = 1; i < 10; i++) {
      console.log(i);
      const currentPage = i;
      const res = await lawService.getAllAttorneys(currentPage);
      const attorneyAray = res.data.data;
      const totalPages = res.data.meta.total_pages;
      attorneyAray.forEach((element) => {
        setAttorneys((prevState) => {
          let updatedFormData = [...prevState];
          if (element.attributes.name !== " ") {
            updatedFormData.push({
              name: element.attributes.name,
              id: element.id,
            });
          }
          return updatedFormData;
        });
      });
      if (currentPage == totalPages) {
        return;
      }
    }
    console.log("done");
  };

  const createAttorneyLIst = useEffect(() => {
    getAttorneyNames();
    window.history.replaceState({}, "");
    const param = searchParams.get("tp");
    setParams((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData.param = param;
      return updatedFormData;
    });
  }, []);

  const onFormFieldChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setQuantities((prevState) => {
      console.log(Number(quantities["Assembled Padded Binder"]));
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData[name] = value;
      return updatedFormData;
    });
    console.log(quantities);
  };
  const onCouponFieldChanged = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setCouponInput((prevState) => {
      console.log("updater onChange");
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData[name] = value;
      return updatedFormData;
    });
  };

  const onConfirmFieldChanged = (event) => {
    const index = event.target?.selectedIndex;
    const currentAttorney = attorneys[index];
    const id = currentAttorney?.id;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    localStorage.setItem(name, value);
    setConfirmInput((prevState) => {
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData[name] = value;
      updatedFormData.processorConfirmId = id
        ? id
        : updatedFormData.processorConfirmId;
      return updatedFormData;
    });
  };
  function addToCartClicked(e) {
    var title = e.target.name;
    addItemToCart(title);
  }
  function addItemToCart(title) {
    if (quantities[title] !== 0) {
      setQuantities((prevState) => {
        console.log("updater onChange");
        const updatedFormData = {
          ...prevState,
        };
        let quantNum = Number(updatedFormData[title]);
        quantNum = quantNum + 1;
        let quantNumStr = quantNum.toString();
        updatedFormData[title] = quantNumStr;
        return updatedFormData;
      });
    } else {
      setQuantities((prevState) => {
        console.log("updater onChange");
        const updatedFormData = {
          ...prevState,
        };
        updatedFormData[title] = "1";
        return updatedFormData;
      });
    }
  }
  // useEffect(()=>{
  // checkOnlyTrustPlus()
  // },[quantities["Trust Guard Plan Plus"]])

  // const checkOnlyTrustPlus=()=>{
  //   const copyquants={...quantities}
  //   delete copyquants["Trust Guard Plan Plus"]
  // const otherThingsThanTrustPlus = Object.values(copyquants).some(
  //         (item) => item > 0
  //       );
  // if((Number(quantities["Trust Guard Plan Plus"])>0)){
  //   setTrustPlus((ps) => {

  //         const pd = {
  //           ...ps,
  //         };
  //         pd.onlyTrustPlus=true
  //         return pd;
  //       });
  // }
  // else{
  //   setTrustPlus((ps) => {

  //         const pd = {
  //           ...ps,
  //         };
  //         pd.onlyTrustPlus=false
  //         return pd;
  //       });
  // }

  // }
  const removeCartItem = (e) => {
    var title = e.target.name;
    setQuantities((prevState) => {
      console.log("updater onChange");
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData[title] = "0";
      return updatedFormData;
    });
  };
  function updateCartTotal() {
    let total = 0;
    for (const cost in quantities) {
      const quant = Number(quantities[cost]);
      const price = Number(prices[cost]);
      total = total + quant * price;
    }
    // const quant = Number(quantities[title])
    // const cost=Number(prices[title])
    // var total = quant * cost
    total = Math.round(total * 100) / 100;
    setCartTotal((prevState) => {
      const pd = {
        ...prevState,
      };
      const savings = pd.appliedDiscounts;
      const depositAmount = pd.depositAmount;
      pd.finalPrice = total + savings - depositAmount;
      pd.prediscount = total;
      return pd;
    });
  }
  useEffect(() => {
    updateCartTotal();
    setDiscounts((prevState) => {
      const pd = {
        ...prevState,
      };
      pd["IGNAGENT"].restriction =
        quantities["Trust Guard Plan"] >= 1 ||
        quantities["Trust Guard Plan (No Deed)"] >= 1 ||
        (quantities["Trust Guard Plan (Old Pricing)"] >= 1 &&
          quantities["Assembled Padded Binder"] > 0);
      return pd;
    });
  }, [quantities, cartTotal.depositAmount]);

  function applyCoupon() {
    var couponCode = couponInput.codeInput;
    var fomattedCode = couponCode.toLocaleUpperCase();
    var couponItem = discounts[fomattedCode];
    var couponValue = couponItem?.value;
    var couponOperator = couponItem?.operator;
    var couponRestriction = couponItem?.restriction;
    var notPreviouslyUsed = discounts.used[fomattedCode] ? false : true;
    let total = cartTotal.finalPrice;
    if (couponRestriction && notPreviouslyUsed) {
      setCartTotal((prevState) => {
        const pd = {
          ...prevState,
        };
        console.log(total);
        couponOperator === "add"
          ? (total = total + couponValue)
          : (total = total * couponValue);
        console.log(total);
        pd.finalPrice = total;
        pd.appliedDiscounts = couponValue;
        return pd;
      });
      setDiscounts((prevState) => {
        const pd = {
          ...prevState,
        };
        pd.used[fomattedCode] = true;
        return pd;
      });
      if (fomattedCode === "MOMS25") {
        alert("Coupon Code: MOMS25 applied");
      }
    } else if (!notPreviouslyUsed) {
      alert("Coupon Code Already Used");
    } else {
      alert("Invalid Coupon Code");
    }
  }

  function confirmClicked(e) {
    e.preventDefault();
    let clientEmail = couponInput.clientEmail;
    lawService
      .getMatterByEmail(clientEmail)
      .then((r) => {
        onGetMatterSuccess(r);
      })
      .catch(() => {
        onGetMatterFail();
      });
  }
  const onGetMatterSuccess = async (r) => {
    const id = r.data.data.id;
    const attorneyId = r.data.data.relationships.lead_attorney.data?.id;
    const originatingAttorneyId =
      r.data.data.relationships.originating_attorney.data?.id;
    const contactId = r.data.data.relationships.contact.data?.id;
    const clientName = r.data.data.attributes.name;
    const tags = r.data.data.relationships.tags.data;
    let isAttorneyReferral = false;
    let agentPlan = false;
    let providedNotary = false;
    let binderNumber = 0;
    let assignNumber = 0;
    let familyNumber = 0;
    let trustNumber = 0;
    let trustPlusNumber = 0;
    let deedNumber = 0;
    let recordingNumber = 0;
    let deedsToBeDrafted = 0;
    let agentTrustNumber = 0;
    let ammendNumber = 0;
    let spouse = 0;
    let notaryNumber = 0;
    let affidavitNumber = 0;
    let depositAmount = 0;
    let fieldAgentId = 0;
    let attorneyReviewNumber = 0;
    let moms25 = false;
    let attorneyAttend = false;
    let markInheritGold=false
    const attorneyName = attorneyId
      ? await lawService.getAttorneyById(attorneyId)
      : "No Lead Attorney Found";
    const custom_fields = r.data.data.attributes.custom_fields;
    for (let i = 0; i < custom_fields.length; i++) {
      const element = custom_fields[i];
      if (element.id === "471827") {
        agentPlan = element.value;
      }
      if (element.id === "473216") {
        providedNotary = element.value;
      }
      if (element.id === "467401") {
        binderNumber = element.value;
      }
      if (element.id === "467402") {
        assignNumber = element.value;
      }
      if (element.id === "467403") {
        familyNumber = element.value;
      }
      if (element.id === "668690") {
        trustPlusNumber = element.value;
      }
      if (element.id === "467404") {
        trustNumber = element.value;
      }
      if (element.id === "447001") {
        deedNumber = element.value;
      }
      if (element.id === "482996") {
        recordingNumber = element.value;
      }
      if (element.id === "495641") {
        deedsToBeDrafted = element.value;
      }
      if (element.id === "499640") {
        agentTrustNumber = element.value;
      }
      if (element.id === "509812") {
        ammendNumber = element.value;
      }
      if (element.id === "421736") {
        spouse = element.value;
      }
      if (element.id === "541542") {
        notaryNumber = element.value;
      }
      if (element.id === "573951") {
        affidavitNumber = element.value;
      }
      if (element.id === "563798") {
        depositAmount = element.value;
      }
      if (element.id === "422722") {
        fieldAgentId = element.value;
      }
      if (element.id === "591840") {
        moms25 = element.value;
      }
      // if (element.id === "705820") {
      //   attorneyAttend = element.value;
      // }
      if (element.id === "758255") {
        attorneyReviewNumber = element.value;
      }
    }
    for (let j = 0; j < tags.length; j++) {
      const currentTag = tags[j];
      if (currentTag.id === "130891") {
        isAttorneyReferral = true;
      }
    }
    let fetchedValue = r.data.data.attributes.actual_value_cents;
    setCartTotal((prevState) => {
      const pd = {
        ...prevState,
      };
      pd.actualValue = fetchedValue;
      pd.depositAmount = depositAmount / 100;
      return pd;
    });
    setConfirmInput((prevState) => {
      console.log("updater onChange");
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData["clientConfirm"] = clientName;
      updatedFormData["processorConfirm"] = attorneyName;
      updatedFormData.searchedClient = true;
      updatedFormData.clientId = id;
      updatedFormData.processorConfirmId = attorneyId ? attorneyId : null;
      updatedFormData.isAgentPlan = agentPlan;
      updatedFormData.binderNumber = binderNumber;
      updatedFormData.assignNumber = assignNumber;
      updatedFormData.familyNumber = familyNumber;
      updatedFormData.trustPlusNumber = trustPlusNumber;
      updatedFormData.trustNumber = trustNumber;
      updatedFormData.deedNumber = deedNumber;
      updatedFormData.recordingNumber = recordingNumber;
      updatedFormData.deedsToBeDrafted = deedsToBeDrafted;
      updatedFormData.agentTrustNumber = agentTrustNumber;
      updatedFormData.ammendNumber = ammendNumber;
      updatedFormData.spouseConfirm = spouse;
      updatedFormData.notaryNumber = notaryNumber;
      updatedFormData.attorneyReviewNumber = attorneyReviewNumber;
      updatedFormData.affidavitNumber = affidavitNumber;
      updatedFormData.depositAmount = depositAmount;
      updatedFormData.fieldAgentId = fieldAgentId;
      updatedFormData.leadAttorney = attorneyId;
      updatedFormData.originatingAttorney = originatingAttorneyId;
      updatedFormData.moms25 = moms25;
      updatedFormData.contactId = contactId;
      updatedFormData.isAttorneyReferral = isAttorneyReferral;
      updatedFormData.attorneyAttend = agentAttend;
      return updatedFormData;
    });
  };
  const onGetMatterFail = () => {
    setConfirmInput((prevState) => {
      console.log("updater onChange");
      const updatedFormData = {
        ...prevState,
      };
      updatedFormData.searchedClient = true;
      updatedFormData["processorConfirm"] = "No Lead Attorney Found";
      updatedFormData["clientConfirm"] = "";
      updatedFormData.clientId = null;
      updatedFormData.processorConfirmId = null;
      return updatedFormData;
    });
    alert(
      "No client found with that email. Please ensure email is correct or enter\nclient information manually below.",
    );
  };

  function decidePlan() {
    let trustPlanAdded = "";
    let familyPlanAdded = "";
    let trustPlusPlanAdded = "";
    let trustPlanAgentOrNot = discounts.used.IGNAGENT
      ? "Agent Trust Guard Plan"
      : "Trust Guard Plan";
    let totalTrustGuardPlans =
      Number(quantities["Trust Guard Plan"]) +
      Number(quantities["Trust Guard Plan (Old Pricing)"]) +
      Number(quantities["Trust Guard Plan (No Deed)"]);
    let planAdded = "";
    if (totalTrustGuardPlans > 0) {
      trustPlanAdded =
        trustPlanAdded + (totalTrustGuardPlans > 1)
          ? `${totalTrustGuardPlans} ${trustPlanAgentOrNot}`
          : trustPlanAgentOrNot;
      planAdded = trustPlanAdded;
    }
    if (quantities["Family Guard Plan"] > 0) {
      familyPlanAdded =
        familyPlanAdded + quantities["Family Guard Plan"] > 1
          ? `${quantities["Family Guard Plan"]} Family Guard Plans`
          : "Family Guard Plan";
      planAdded = planAdded
        ? `${planAdded} and ${familyPlanAdded}`
        : familyPlanAdded;
    }
    if (quantities["Trust Guard Plan Plus"] > 0) {
      trustPlusPlanAdded =
        trustPlusPlanAdded + quantities["Trust Guard Plan Plus"] > 1
          ? `${quantities["Trust Guard Plan Plus"]} Trust Guard Plans Plus`
          : "Trust Guard Plan Plus";
      planAdded = planAdded
        ? `${planAdded} and ${trustPlusPlanAdded}`
        : trustPlusPlanAdded;
    }
    // if (
    //   quantities["Family Guard Plan"] > 0 &&
    //   quantities["Trust Guard Plan"] > 0
    // ) {
    //   planAdded = `${trustPlanAdded} and ${familyPlanAdded}`;
    // } else {
    //   planAdded =
    //     quantities["Family Guard Plan"] > 0 ? familyPlanAdded : trustPlanAdded;
    // }
    return planAdded;
  }

  return (
    <>
      <div>
        <div class="container">
          <section class="container content-section">
            <h2 class="section-header">Estate Plan Choice:</h2>
            <hr />
            {params.param != "trustplus" && (
              <div class="shop-item">
                <div class="shop-item-details">
                  <span class="shop-item-title">
                    {discounts.used.IGNAGENT
                      ? "Agent Trust Guard Plan"
                      : "Trust Guard Plan"}
                  </span>
                  <span class="shop-item-price">
                    ${numberWithCommas(prices["Trust Guard Plan"])}
                  </span>
                  {/* <input
                class="shop-quantity-input"
                type="number"
                name="Trust Guard Plan"
                id="TrustGuard Amount"
                value={quantities["Trust Guard Plan"]}
                onChange={onFormFieldChange}
              /> */}
                  <button
                    class="btn2 btn-primary shop-item-button"
                    name="Trust Guard Plan"
                    type="button"
                    onClick={addToCartClicked}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            )}
            {false && (
              <div class="shop-item">
                <div class="shop-item-details">
                  <span class="shop-item-title">
                    {discounts.used.IGNAGENT
                      ? "Agent Trust Guard Plan"
                      : "Trust Guard Plan"}
                    <span className="small">(No Deed)</span>
                  </span>
                  <span class="shop-item-price">
                    ${numberWithCommas(prices["Trust Guard Plan (No Deed)"])}
                  </span>
                  {/* <input
                class="shop-quantity-input"
                type="number"
                name="Trust Guard Plan"
                id="TrustGuard Amount"
                value={quantities["Trust Guard Plan"]}
                onChange={onFormFieldChange}
              /> */}
                  <button
                    class="btn2 btn-primary shop-item-button"
                    name="Trust Guard Plan (No Deed)"
                    type="button"
                    onClick={addToCartClicked}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            )}
            <div class="shop-item">
              <div class="shop-item-details">
                <span class="shop-item-title">
                  {discounts.used.IGNAGENT
                    ? "Agent Trust Guard Plan Plus"
                    : "Trust Guard Plan Plus"}
                </span>
                <span class="shop-item-price">
                  ${numberWithCommas(prices["Trust Guard Plan Plus"])}
                </span>
                {/* <input
                class="shop-quantity-input"
                type="number"
                name="Trust Guard Plan"
                id="TrustGuard Amount"
                value={quantities["Trust Guard Plan"]}
                onChange={onFormFieldChange}
              /> */}
                <button
                  class="btn2 btn-primary shop-item-button"
                  name="Trust Guard Plan Plus"
                  type="button"
                  onClick={addToCartClicked}
                >
                  ADD TO CART
                </button>
              </div>
            </div>
            {false && (
              <div class="shop-item">
                <div class="shop-item-details">
                  <span class="shop-item-title">
                    {discounts.used.IGNAGENT
                      ? "Agent Trust Guard Plan"
                      : "Trust Guard Plan"}
                    <span className="small">(Old Pricing)</span>
                  </span>
                  <span class="shop-item-price">
                    $
                    {numberWithCommas(prices["Trust Guard Plan (Old Pricing)"])}
                  </span>
                  {/* <input
                class="shop-quantity-input"
                type="number"
                name="Trust Guard Plan"
                id="TrustGuard Amount"
                value={quantities["Trust Guard Plan"]}
                onChange={onFormFieldChange}
              /> */}
                  <button
                    class="btn2 btn-primary shop-item-button"
                    name="Trust Guard Plan (Old Pricing)"
                    type="button"
                    onClick={addToCartClicked}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            )}
            {params.param != "trustplus" && (
              <div class="shop-item">
                <div class="shop-item-details">
                  <span class="shop-item-title">
                    Family Guard Plan
                    <span className="small">(Notary Not Included)</span>
                  </span>
                  <span class="shop-item-price">$650.00</span>
                  {/* <input
                class="shop-quantity-input"
                type="number"
                name="Family Guard Plan"
                value={quantities["Family Guard Plan"]}
                onChange={onFormFieldChange}
              /> */}
                  <button
                    class="btn2 btn-primary shop-item-button"
                    type="button"
                    name="Family Guard Plan"
                    onClick={addToCartClicked}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            )}
            {params.param != "trustplus" && (
              <div class="shop-item">
                <div class="shop-item-details">
                  <span class="shop-item-title">
                    Trust Guard Amendment/Restatement{" "}
                    <span className="small">(Notary Not Included)</span>
                  </span>

                  <span class="shop-item-price">$350.00</span>
                  {/* <input
                class="shop-quantity-input"
                type="number"
                name="Family Guard Plan"
                value={quantities["Family Guard Plan"]}
                onChange={onFormFieldChange}
              /> */}
                  <button
                    class="btn2 btn-primary shop-item-button"
                    type="button"
                    name="Trust Guard Ammendment/Restatement"
                    onClick={addToCartClicked}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            )}
            {params.param != "trustplus" && (
              <div class="shop-item">
                <div class="shop-item-details">
                  <span class="shop-item-title">Design Meeting Deposit</span>

                  <span class="shop-item-price">$100.00</span>
                  <button
                    class="btn2 btn-primary shop-item-button"
                    type="button"
                    name="Design Meeting Deposit"
                    onClick={addToCartClicked}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            )}

            <h2 class="section-header">Additional Options:</h2>
            <hr />
            <div class="shop-item">
              <div class="shop-item-details">
                <span class="shop-item-title">
                  {" "}
                  Additional Deed{" "}
                  <span className="small">
                    (Includes Electronic Recording Where Available)
                  </span>
                </span>
                <span class="shop-item-price">$200.00</span>
                {/* <input
                class="shop-quantity-input"
                type="number"
                name="Additional Deed"
                value={quantities["Additional Deed"]}
                onChange={onFormFieldChange}
              /> */}
                <button
                  class="btn2 btn-primary shop-item-button"
                  type="button"
                  name="Additional Deed"
                  onClick={addToCartClicked}
                >
                  ADD TO CART
                </button>
              </div>
            </div>
            {params.param != "trustplus" && (
              <div class="shop-item">
                <div class="shop-item-details">
                  <span class="shop-item-title">
                    Affidavit of Death of Joint Tenant
                  </span>

                  <span class="shop-item-price">$150.00</span>
                  <button
                    class="btn2 btn-primary shop-item-button"
                    type="button"
                    name="Affidavit of Death of Joint Tenant"
                    onClick={addToCartClicked}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            )}
            {params.param != "trustplus" && (
              <div class="shop-item">
                <div class="shop-item-details">
                  <span class="shop-item-title">
                    Assembled Padded Binder{" "}
                    <span className="small">
                      (One Included with TrustGuard Plus+ Plan)
                    </span>
                  </span>

                  <span class="shop-item-price">$100.00</span>
                  {/* <input
                class="shop-quantity-input"
                type="number"
                name="Assembled Padded Binder"
                value={quantities["Assembled Padded Binder"]}
                onChange={onFormFieldChange}
              /> */}
                  <button
                    class="btn2 btn-primary shop-item-button"
                    type="button"
                    name="Assembled Padded Binder"
                    onClick={addToCartClicked}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            )}
            {params.param != "trustplus" && (
              <div class="shop-item">
                <div class="shop-item-details">
                  <span class="shop-item-title">
                    Notary <span className="small">(In Home or Office)</span>
                  </span>

                  <span class="shop-item-price">$200.00</span>
                  <button
                    class="btn2 btn-primary shop-item-button"
                    type="button"
                    name="Notary"
                    onClick={addToCartClicked}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            )}
            {params.param != "trustplus" && (
              <div class="shop-item">
                <div class="shop-item-details">
                  <span class="shop-item-title">Attorney Review</span>

                  <span class="shop-item-price">$399.00</span>
                  <button
                    class="btn2 btn-primary shop-item-button"
                    type="button"
                    name="Attorney Review"
                    onClick={addToCartClicked}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            )}
            {params.param != "trustplus" && (
              <div class="shop-item">
                <div class="shop-item-details">
                  <span class="shop-item-title">Assignment of Business</span>
                  <span class="shop-item-price">$250.00</span>
                  {/* <input
                class="shop-quantity-input"
                type="number"
                name="Assignment of Business"
                value={quantities["Assignment of Business"]}
                onChange={onFormFieldChange}
              /> */}
                  <button
                    class="btn2 btn-primary shop-item-button"
                    type="button"
                    name="Assignment of Business"
                    onClick={addToCartClicked}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            )}
            {params.param != "trustplus" && (
              <div class="shop-item">
                <div class="shop-item-details">
                  <span class="shop-item-title">
                    Electronic Recording
                    <span className="small">(Included with All Deeds)</span>
                    <span className="small">
                      (County Recorder Fees Are Additional)
                    </span>
                  </span>

                  <span class="shop-item-price">$50.00</span>
                  {/* <input
                class="shop-quantity-input"
                type="number"
                name="Assignment of Business"
                value={quantities["Assignment of Business"]}
                onChange={onFormFieldChange}
              /> */}
                  <button
                    class="btn2 btn-primary shop-item-button"
                    type="button"
                    name="Electronic Recording"
                    onClick={addToCartClicked}
                  >
                    ADD TO CART
                  </button>
                </div>
                <div style={{ "font-size": "15px" }}>
                  Note: E-Recordings are Unavailable in New York, Maryland, and
                  Illinois
                </div>
              </div>
            )}
          </section>
          <section class="container content-section">
            <h2 class="section-header">CART</h2>
            <div class="cart-row">
              <span class="cart-item cart-header cart-column">ITEM</span>
              <span class="cart-price cart-header cart-column">PRICE</span>
              <span class="cart-quantity cart-header cart-column">
                QUANTITY
              </span>
            </div>
            <div class="cart-items">
              {quantities["Trust Guard Plan"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">
                      {discounts.used.IGNAGENT
                        ? "Agent Trust Guard Plan"
                        : "Trust Guard Plan"}
                    </span>
                  </div>
                  <span class="cart-price cart-column">
                    ${numberWithCommas(prices["Trust Guard Plan"])}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Trust Guard Plan"
                      value={quantities["Trust Guard Plan"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Trust Guard Plan"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Trust Guard Plan (No Deed)"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">
                      {discounts.used.IGNAGENT
                        ? "Agent Trust Guard Plan (No Deed)"
                        : "Trust Guard Plan (No Deed)"}
                    </span>
                  </div>
                  <span class="cart-price cart-column">
                    ${numberWithCommas(prices["Trust Guard Plan (No Deed)"])}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Trust Guard Plan (No Deed)"
                      value={quantities["Trust Guard Plan (No Deed)"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Trust Guard Plan (No Deed)"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Trust Guard Plan Plus"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">
                      {discounts.used.IGNAGENT
                        ? "Agent Trust Guard Plan Plus"
                        : "Trust Guard Plan Plus"}
                    </span>
                  </div>
                  <span class="cart-price cart-column">
                    ${numberWithCommas(prices["Trust Guard Plan Plus"])}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Trust Guard Plan Plus"
                      value={quantities["Trust Guard Plan Plus"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Trust Guard Plan Plus"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Trust Guard Plan (Old Pricing)"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">
                      {discounts.used.IGNAGENT
                        ? "Agent Trust Guard Plan (Old Pricing)"
                        : "Trust Guard Plan (Old Pricing)"}
                    </span>
                  </div>
                  <span class="cart-price cart-column">
                    $
                    {numberWithCommas(prices["Trust Guard Plan (Old Pricing)"])}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Trust Guard Plan (Old Pricing)"
                      value={quantities["Trust Guard Plan (Old Pricing)"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Trust Guard Plan (Old Pricing)"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Family Guard Plan"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">Family Guard Plan</span>
                  </div>
                  <span class="cart-price cart-column">
                    ${prices["Family Guard Plan"]}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Family Guard Plan"
                      value={quantities["Family Guard Plan"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Family Guard Plan"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Additional Deed"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">Additional Deed</span>
                  </div>
                  <span class="cart-price cart-column">
                    ${prices["Additional Deed"]}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Additional Deed"
                      value={quantities["Additional Deed"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Additional Deed"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Affidavit of Death of Joint Tenant"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">
                      Affidavit of Death of Joint Tenant
                    </span>
                  </div>
                  <span class="cart-price cart-column">
                    ${prices["Affidavit of Death of Joint Tenant"]}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Affidavit of Death of Joint Tenant"
                      value={quantities["Affidavit of Death of Joint Tenant"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Affidavit of Death of Joint Tenant"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Design Meeting Deposit"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">Design Meeting Deposit</span>
                  </div>
                  <span class="cart-price cart-column">
                    ${prices["Design Meeting Deposit"]}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Design Meeting Deposit"
                      value={quantities["Design Meeting Deposit"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Design Meeting Deposit"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Assembled Padded Binder"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">Assembled Padded Binder</span>
                  </div>
                  <span class="cart-price cart-column">
                    ${prices["Assembled Padded Binder"]}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Assembled Padded Binder"
                      value={quantities["Assembled Padded Binder"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Assembled Padded Binder"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Notary"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">Notary</span>
                  </div>
                  <span class="cart-price cart-column">
                    ${prices["Notary"]}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Notary"
                      value={quantities["Notary"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Notary"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Attorney Review"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">Attorney Review</span>
                  </div>
                  <span class="cart-price cart-column">
                    ${prices["Attorney Review"]}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Attorney Review"
                      value={quantities["Attorney Review"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Attorney Review"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Assignment of Business"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">Assignment of Business</span>
                  </div>
                  <span class="cart-price cart-column">
                    ${prices["Assignment of Business"]}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Assignment of Business"
                      value={quantities["Assignment of Business"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Assignment of Business"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Electronic Recording"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">Electronic Recording</span>
                  </div>
                  <span class="cart-price cart-column">
                    ${prices["Electronic Recording"]}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Electronic Recording"
                      value={quantities["Electronic Recording"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Electronic Recording"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-items">
              {quantities["Trust Guard Ammendment/Restatement"] > 0 && (
                <div class="cart-row">
                  <div class="cart-item cart-column">
                    <span class="cart-item-title">
                      Trust Guard Amendment/Restatement
                    </span>
                  </div>
                  <span class="cart-price cart-column">
                    ${prices["Trust Guard Ammendment/Restatement"]}
                  </span>
                  <div class="cart-quantity cart-column">
                    <input
                      class="cart-quantity-input"
                      type="number"
                      name="Trust Guard Ammendment/Restatement"
                      value={quantities["Trust Guard Ammendment/Restatement"]}
                      onChange={onFormFieldChange}
                    />
                    <button
                      class="btn2 btn-danger"
                      type="button"
                      name="Trust Guard Ammendment/Restatement"
                      onClick={removeCartItem}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div class="cart-total">
              <strong class="cart-total-title">Subtotal</strong>
              <span class="cart-total-price">
                ${numberWithCommas(cartTotal.prediscount)}
              </span>
            </div>

            {cartTotal.depositAmount > 0 && (
              <>
                <div style={{ "margin-left": "78%", color: "red" }}>
                  <p className="">
                    {`Deposit Applied ($${cartTotal.depositAmount}
                Off)`}{" "}
                  </p>
                </div>
              </>
            )}
            <div class="cart-total">
              <strong class="cart-total-title">Total</strong>
              <span class="cart-total-price">
                ${numberWithCommas(cartTotal.finalPrice)}
              </span>
            </div>
            <div class="cart-row">
              <input
                class="coupon-item cart-header cart-column"
                id="coupon-input"
                type="text"
                name="codeInput"
                placeholder="Enter Code"
                value={couponInput.codeInput}
                onChange={onCouponFieldChanged}
              />
            </div>
            <div class="cart-row ">
              <button
                class="btn2 btn-primary coupon-button"
                id="coupon-button"
                onClick={applyCoupon}
              >
                Apply Code
              </button>
            </div>
          </section>
          <section className="container content-section">
            {/* {(searchParams.get("tp")!="trustplus")?(!trustPlus.onlyTrustPlus):true  && ( */}
            {(params.param === "trustplus" ? false : true) && (
              <form onSubmit={confirmClicked}>
                <div>
                  <label
                    class="cart-item cart-header cart-column"
                    for="clientEmail"
                  >
                    Please Input Client's Email (Use Same Email in Lawmatics)
                  </label>
                  <input
                    required
                    class="name-input cart-item cart-header cart-column email-input"
                    type="email"
                    id="clientEmail"
                    value={couponInput.clientEmail}
                    name="clientEmail"
                    onChange={onCouponFieldChanged}
                  />
                  <button
                    class="btn2 btn-primary btn-purchase2"
                    id="confirmButton"
                    type="submit"
                    // onClick={confirmClicked}
                  >
                    Confirm Client info
                  </button>
                </div>
              </form>
            )}
            {confirmInput.searchedClient && (
              <form>
                <div className="cart-row">
                  <label
                    class="cart-item cart-header cart-column"
                    for="clientConfirm"
                  >
                    Confirm Client's Name
                  </label>

                  <label
                    class="cart-item cart-header cart-column ms-3"
                    for="processorConfirm"
                  >
                    Confirm Legal Processor's Name
                  </label>
                </div>
                <div className="cart-row">
                  <input
                    class="name-input cart-item cart-header cart-column email-input"
                    type="text"
                    id=""
                    value={confirmInput.clientConfirm}
                    name="clientConfirm"
                    onChange={onConfirmFieldChanged}
                  />
                  <select
                    class="name-input cart-item cart-header cart-column email-input"
                    value={confirmInput.processorConfirm}
                    name={"processorConfirm"}
                    onChange={onConfirmFieldChanged}
                    style={{ "font-size": "15px" }}
                    id={confirmInput.processorConfirmId}
                  >
                    <optgroup style={{ "font-size": "15px" }}>
                      {/* <option
                    key={"abc"}
                    value={"No Lead Attorney Found"}
                    name={"processorConfirm"}
                    onChange={onConfirmFieldChanged}
                  >
                    No Lead Attorney Found
                  </option> */}
                      {attorneys.map((attorney) => (
                        <option
                          key={attorney.id}
                          value={attorney.name}
                          name={"processorConfirm"}
                          onChange={onConfirmFieldChanged}
                          id={attorney.id}
                        >
                          {attorney.name}
                        </option>
                      ))}
                    </optgroup>
                  </select>
                </div>
                <div className="cart-row">
                <select
                    class="name-input cart-item cart-header cart-column email-input"
                    value={agentAttend}
                    name={"processorConfirm"}
                    onChange={onAgentAttendChanged}
                    style={{ "font-size": "15px" }}
                  >
                    {/* <optgroup style={{ "font-size": "15px" }}> */}
                      <option value={"Did Agent Attend Initial Consult?"} >Did Agent Attend Initial Consult?</option>
                                              <option
                          value={true}
                          name={"yes"}
                          onChange={onAgentAttendChanged}
                        >
                          Yes
                        </option>
                        <option
                          value={false}
                          name={"no"}
                          onChange={onAgentAttendChanged}
                        >
                          No
                        </option>
                    {/* </optgroup> */}
                  </select>
                  </div>
                <button
                  onClick={checkoutClicked}
                  class="btn2 btn-primary btn-purchase3"
                  type="button"
                >
                  Checkout
                </button>
                {locationState.readyToCheckout && (
                  <Navigate to="/checkout" state={locationState}></Navigate>
                )}
              </form>
            )}
            {(params.param === "trustplus" ? true : false) && (
              <form>
                <div className="cart-row">
                  <label
                    class="cart-item cart-header cart-column"
                    for="clientConfirm"
                  >
                    Client First Name
                  </label>

                  <label
                    class="cart-item cart-header cart-column ms-3"
                    for="processorConfirm"
                  >
                    Client Last Name
                  </label>
                </div>
                <div className="cart-row">
                  <input
                    class="name-input cart-item cart-header cart-column email-input"
                    type="text"
                    id=""
                    value={confirmInput.trustPlusFirstName}
                    name="trustPlusFirstName"
                    onChange={onConfirmFieldChanged}
                    required
                  />
                  <input
                    class="name-input cart-item cart-header cart-column email-input"
                    type="text"
                    id=""
                    value={confirmInput.trustPlusLastName}
                    name="trustPlusLastName"
                    onChange={onConfirmFieldChanged}
                    required
                  />
                </div>
                <div className="cart-row">
                  <label
                    class="cart-item cart-header cart-column"
                    for="clientConfirm"
                  >
                    Client Email
                  </label>

                  <label
                    class="cart-item cart-header cart-column ms-3"
                    for="processorConfirm"
                  >
                    Client Phone
                  </label>
                </div>
                <div className="cart-row">
                  <input
                    class="name-input cart-item cart-header cart-column email-input"
                    type="text"
                    id=""
                    value={confirmInput.trustPlusEmail}
                    name="trustPlusEmail"
                    onChange={onConfirmFieldChanged}
                    required
                  />
                  <input
                    class="name-input cart-item cart-header cart-column email-input"
                    type="text"
                    id=""
                    value={confirmInput.trustPlusPhone}
                    name="trustPlusPhone"
                    onChange={onConfirmFieldChanged}
                    required
                  />
                </div>
                <button
                  class="btn2 btn-primary btn-purchase3"
                  type="button"
                  onClick={trustPlusCheckoutClicked}
                >
                  Checkout
                </button>
                {locationState.readyToCheckout && (
                  <Navigate to="/checkout" state={locationState}></Navigate>
                )}
              </form>
            )}
          </section>
        </div>
      </div>
    
    </>
  );
}

export default NewCart;
